export enum AccessLevels {
  Read = 'R',
  Write = 'W'
}
